module.exports = __webpack_public_path__ + "static/media/sidebar-4.fc9cb053.jpg";